
import React, { useState } from 'react';

export const TestimonialsSection: React.FC = () => {
  const [activeTestimonial, setActiveTestimonial] = useState(0);

  const testimonials = [
    {
      name: 'Jennifer Martinez',
      title: 'CEO, TechStart Solutions',
      company: 'Technology Startup',
      rating: 5,
      text: 'FinDev Advisory transformed our business financial strategy completely. Their business development consulting helped us secure $2M in funding and optimize our cash flow. Sarah and her team provided invaluable guidance that directly contributed to our 300% revenue growth over 18 months.',
      image: 'https://public.readdy.ai/ai/img_res/bf1e5ec30128cc4b604e5a44eced6eec.jpg'
    },
    {
      name: 'Robert Kim',
      title: 'Senior Director',
      company: 'Fortune 500 Company',
      rating: 5,
      text: 'The career coaching services from Emily were exceptional. She helped me navigate a complex career transition and negotiate a 40% salary increase. The strategic approach to professional development and leadership coaching has been instrumental in my advancement to senior director level.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20male%20executive%20in%20premium%20business%20suit%2C%20confident%20and%20distinguished%20appearance%2C%20upscale%20corporate%20office%20environment%2C%20professional%20headshot%20with%20sophisticated%20lighting&width=300&height=300&seq=testimonial-002&orientation=squarish'
    },
    {
      name: 'Lisa Thompson',
      title: 'Retired Educator',
      company: 'Personal Client',
      rating: 5,
      text: 'David helped us plan for retirement with such precision and care. His wealth management expertise ensured we could retire comfortably at 62. The comprehensive financial planning and investment strategies have given us peace of mind and financial security for our golden years.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20mature%20woman%20with%20warm%20smile%2C%20elegant%20and%20approachable%20appearance%2C%20comfortable%20home%20office%20setting%2C%20professional%20portrait%20with%20natural%20lighting%20and%20friendly%20demeanor&width=300&height=300&seq=testimonial-003&orientation=squarish'
    },
    {
      name: 'Mark Anderson',
      title: 'Small Business Owner',
      company: 'Anderson Construction',
      rating: 5,
      text: 'Michael\'s business development consulting was a game-changer for our construction company. He helped us streamline operations, expand into new markets, and increase our profit margins by 35%. The strategic planning and market analysis were spot-on and delivered real results.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20male%20business%20owner%20in%20casual%20business%20attire%2C%20approachable%20and%20hardworking%20appearance%2C%20construction%20office%20environment%20with%20blueprints%2C%20professional%20headshot%20with%20natural%20lighting&width=300&height=300&seq=testimonial-004&orientation=squarish'
    },
    {
      name: 'Amanda Foster',
      title: 'Marketing Manager',
      company: 'Digital Agency',
      rating: 5,
      text: 'The financial planning services exceeded all expectations. Sarah helped me create a comprehensive investment portfolio and tax optimization strategy that has already saved me thousands. Her expertise in financial planning and investment advisory is truly remarkable.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20young%20female%20marketing%20professional%20in%20modern%20business%20attire%2C%20creative%20and%20energetic%20appearance%2C%20contemporary%20office%20environment%2C%20professional%20headshot%20with%20bright%20lighting&width=300&height=300&seq=testimonial-005&orientation=squarish'
    }
  ];

  return (
    <section id="testimonials" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6" style={{ fontFamily: '"Playfair Display", serif' }}>
            Client <span className="text-blue-600">Success Stories</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Discover how our financial advisory and business development services have helped clients achieve 
            their goals and transform their financial futures through strategic planning and expert guidance.
          </p>
        </div>

        <div className="relative">
          <div className="bg-gray-50 rounded-3xl p-8 md:p-12">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
              <div>
                <div className="flex items-center mb-6">
                  <img 
                    src={testimonials[activeTestimonial].image}
                    alt={testimonials[activeTestimonial].name}
                    className="w-20 h-20 rounded-full object-cover object-top mr-6"
                  />
                  <div>
                    <h3 className="text-xl font-bold text-gray-900">
                      {testimonials[activeTestimonial].name}
                    </h3>
                    <p className="text-blue-600 font-semibold">
                      {testimonials[activeTestimonial].title}
                    </p>
                    <p className="text-gray-600 text-sm">
                      {testimonials[activeTestimonial].company}
                    </p>
                  </div>
                </div>
                
                <div className="flex mb-6">
                  {[...Array(testimonials[activeTestimonial].rating)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-yellow-400 text-xl"></i>
                  ))}
                </div>
                
                <blockquote className="text-lg text-gray-700 leading-relaxed italic">
                  "Hugh Muir Investment transformed our business financial strategy completely. Their investment management consulting helped us secure $2M in funding and optimize our portfolio allocation. The team provided invaluable guidance that directly contributed to our 300% portfolio growth over 18 months."
                </blockquote>
              </div>
              
              <div className="relative">
                <img 
                  src="https://readdy.ai/api/search-image?query=Professional%20business%20success%20celebration%20with%20financial%20charts%20showing%20growth%2C%20modern%20office%20environment%20with%20team%20celebrating%20achievements%2C%20positive%20business%20atmosphere%20with%20financial%20documents%20and%20success%20metrics%20displayed&width=600&height=500&seq=testimonial-bg-001&orientation=landscape"
                  alt="Client Success"
                  className="w-full rounded-2xl shadow-lg object-cover object-top"
                />
                
                <div className="absolute -bottom-6 -right-6 bg-white rounded-2xl shadow-xl p-6 max-w-xs">
                  <div className="text-center">
                    <div className="text-3xl font-bold text-blue-600 mb-1">98%</div>
                    <div className="text-gray-600 font-medium">Client Satisfaction</div>
                    <div className="text-sm text-gray-500 mt-2">Based on 500+ reviews</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <div className="flex justify-center mt-8 space-x-3">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => setActiveTestimonial(index)}
                className={`w-3 h-3 rounded-full transition-colors cursor-pointer ${
                  index === activeTestimonial ? 'bg-blue-600' : 'bg-gray-300'
                }`}
              />
            ))}
          </div>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="text-center p-6 bg-blue-50 rounded-2xl">
            <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-trophy-line text-2xl text-white"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-2">Award-Winning Service</h3>
            <p className="text-gray-600">Recognized for excellence in financial advisory and client satisfaction</p>
          </div>
          
          <div className="text-center p-6 bg-teal-50 rounded-2xl">
            <div className="w-16 h-16 bg-teal-600 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-shield-check-line text-2xl text-white"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-2">Trusted Expertise</h3>
            <p className="text-gray-600">15+ years of proven results and client success stories</p>
          </div>
          
          <div className="text-center p-6 bg-indigo-50 rounded-2xl">
            <div className="w-16 h-16 bg-indigo-600 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-customer-service-line text-2xl text-white"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-2">Personalized Support</h3>
            <p className="text-gray-600">Dedicated advisors providing customized solutions for every client</p>
          </div>
        </div>
      </div>
    </section>
  );
};
